<template>
  <el-card
    v-loading="loading"
    class="clear-card coworkers"
    shadow="hover"
    :body-style="{
      padding: 0
    }"
  >
    <div
      slot="header"
      class="header defaultCursor"
    >
      <span>{{ $t('coach.leader.coworkers.title') }}</span>

      <el-button
        class="clearBtn"
        type="plain"
        round
        @click="goToCoworkerManagement"
      >
        {{ $t('coach.leader.coworkers.manageCoworkers') }}
      </el-button>
    </div>

    <div class="content">
      <el-table
        :data="coworkers"
        style="width: 100%;"
        class="clear-table coworkersTable"
      >
        <template #empty>
          <div style="color: #c4c4c4; font-style: italic; font-size: 16px;">
            {{ $t('common.noData') }}
          </div>
        </template>
        <el-table-column
          :label="$t('coach.leader.coworkers.relationship')"
          :width="['desktop', 'laptop'].includes($mq) ? 180 : null"
        >
          <template slot-scope="scope">
            <span>{{ $t(`stakeholderGroup.${scope.row.org_relationship}`) }}</span>
          </template>
        </el-table-column>

        <el-table-column
          :label="$t('common.name')"
          :width="['desktop', 'laptop'].includes($mq) ? 250 : null"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.first_name }} {{ scope.row.last_name }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="email"
          :label="$t('common.email')"
        />
      </el-table>
    </div>
  </el-card>
</template>

<script>
export default {
  name: 'CoworkersTable',

  props: {
    coworkers: {
      type: Array,
      default: null,
    },

    loading: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    goToCoworkerManagement() {
      this.$router.push({
        name: 'myLeaderCoworkers',
        params: {
          id: this.$route.params.id,
        },
      });
    },
  },
};
</script>

<style lang="scss">
.coworkers {
  margin-bottom: 15px;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: bold;
  }

  .coworkersTable {
    border-radius: 0;
    background-color: transparent;

    thead tr th:first-child .cell {
      padding-left: 20px;
    }

    tbody tr td:first-child .cell {
      padding-left: 20px;
    }
  }

  .clearBtn {
    padding: 13px 15px;
    background-color: transparent;
    word-break: break-word;
    white-space: normal;
    color: var(--themeFontColor);
    border-color: var(--themeFontColor);

    &:hover {
      background: rgba(255, 255, 255, 0.1);
    }
  }
}
</style>
